<template>
  <a-config-provider :locale="zhCN">
    <router-view :key="route.fullPath" />
    <BackToTop />
  </a-config-provider>
</template>

<script lang="ts" setup>
defineOptions({ name: 'App' });

import BackToTop from '@/components/BackToTop/index.vue';
import { useRoute } from 'vue-router';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

const route = useRoute();
//  组件提供的语言包并不对日期格式化起作用，需要额外导入 moment 语言包
import moment from 'moment';
import 'moment/dist/locale/zh-cn';

moment.locale('cn');
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

/**
 * 主滚动放在 #app 上，避免 html/body overflow:hidden 导致 window 无滚动、回到顶部无法判断位移
 */
html,
body {
  height: 100%;
  overflow: hidden;
}

#app {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
